
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ProfileMenu extends Vue {
  protected isActive = true;
}
